import React from 'react';
import {
  FormGroup,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
} from 'reactstrap';
import { EnterClick } from "../../hooks/EnterClick";

import BotaoCancelar from '../BotaoCancelar';
import BotaoApagar from '../BotaoApagar';

const ModalApagar = (props) => {
  EnterClick(props.toggle, 'Enter')

  return (
    <div>
      <Modal isOpen={props.isOpen} toggle={props.toggle} centered>
        <ModalHeader toggle={props.toggle}>Excluir {props.apagar}</ModalHeader>
        <ModalBody>
          <FormGroup>
            <div>
              <Alert color='danger'>
                <h4 className='alert-heading'>Atenção!</h4>
                <p>
                  Após a confirmação desta tela, os dados não poderão ser
                  recuperados!
                </p>
                <hr />
                <p className='mb-0'>Tem certeza que quer excluir?</p>
              </Alert>
            </div>
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <span onClick={() => props.apagarObjeto()}>
            <BotaoApagar aguardando={props.aguardando} />
          </span>
          <BotaoCancelar className='m-1' onClickCancelar={props.toggle} />
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default ModalApagar;
